export default {
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
  HOME: 'Home',
  END: 'End',

  ARROW_LEFT: 'ArrowLeft',
  ARROW_LEFT_ALT: 'Left',
  ARROW_UP: 'ArrowUp',
  ARROW_UP_ALT: 'Up',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_RIGHT_ALT: 'Right',
  ARROW_DOWN: 'ArrowDown',
  ARROW_DOWN_ALT: 'Down',

  ESCAPE: 'Escape',
  ESCAPE_ALT: 'Esc',

  BACKSPACE: 'Backspace',
  ENTER: 'Enter',
  SPACE: ' ',
  TAB: 'Tab',
};
